import React from 'react';
import './TermsDownload.css';

const TermsDownload = () => {
  const handleDownload = (type) => {
    //llevar a /galicia-terms.pdf para que visualice el pdf
    window.open('/galicia-terms.pdf', '_blank');
  };

  return (
    <section id="terminos" className="terms-download">
      <div className="container">
        <div className="terms-content">
          <div className="terms-text">
            <h2 className="section-title">Términos y Condiciones</h2>
            <p className="section-subtitle">
              Conoce todos los detalles de nuestros servicios y políticas
            </p>
            <div className="terms-description">
              <p>
                Descarga nuestros documentos legales para conocer en detalle las condiciones
                de nuestros servicios, políticas de privacidad y términos de uso.
              </p>
            </div>
          </div>

          <div className="terms-downloads">
            <div className="download-card">
              <div className="download-icon">
                <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <polyline points="14,2 14,8 20,8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <line x1="16" y1="13" x2="8" y2="13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <line x1="16" y1="17" x2="8" y2="17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <polyline points="10,9 9,9 8,9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <div className="download-info">
                <h3>Términos y Condiciones</h3>
                <p>Documento completo con todas las condiciones de servicio</p>
                <span className="file-info">PDF • 430 Kb</span>
              </div>
              <button
                className="btn btn-primary download-btn"
                onClick={() => handleDownload('Términos y Condiciones')}
              >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <polyline points="7,10 12,15 17,10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                Descargar
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TermsDownload;